<script lang="ts" setup>
</script>

<template>

  <RouterView />
</template>

<style lang="scss" scoped>
</style>
